import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InvestigationComponent} from './investigation.component';
import {routing} from './investigation.routing';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MultiSelectModule} from 'primeng/primeng';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
// for loading theme
import {LayoutModule} from '../layout/layout.module';

@NgModule({
  imports: [
    CommonModule,
    routing,
    FormsModule,
    LayoutModule,
    HttpModule,
    BrowserAnimationsModule,
    MultiSelectModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot()
  ],
  declarations: [InvestigationComponent],
  providers: []
})
export class InvestigationModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/investigation/investigation.module.ts